// import Document from '@tiptap/extension-document';
// import Paragraph from '@tiptap/extension-paragraph';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import TextStyle from '@tiptap/extension-text-style';
import Link from '@tiptap/extension-link';
import Color from '@tiptap/extension-color';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Image from '@tiptap/extension-image';
// The followinf extensions seem to work without actually installing them....
// This is very weird so i'm leaving this here for now
// import BulletList from '@tiptap/extension-bullet-list';
// import ListItem from '@tiptap/extension-list-item';
// import OrderedList from '@tiptap/extension-ordered-list';

import FormulasExtension from './formulas-extension';
import DataChipExtension from './data-chip-extension.js';
import MultiSelectChipExtension from './multi-select-chip-extension.js';
import TextParserChipExtension from './text-parser-chip-extension.js';
import DivNodeExtension from './div-extension';

import { FontSize } from './font-size-extension';

/* Private */

/* Public */

function getBasicExtensions(isRichTextEnabled, placeholder) {
	const starterKit = StarterKit.configure({
		heading: isRichTextEnabled,
		hardBreak: isRichTextEnabled,
		bold: isRichTextEnabled,
		italic: isRichTextEnabled,
		strike: isRichTextEnabled,
		code: isRichTextEnabled,
		codeBlock: isRichTextEnabled,
		orderedList: isRichTextEnabled,
		horizontalRule: isRichTextEnabled ? false : 'left',
	});

	return [
		isRichTextEnabled ? TextAlign.configure({ types: ['heading', 'paragraph'] }) : false,
		starterKit,
		FormulasExtension,
		DataChipExtension,
		MultiSelectChipExtension,
		TextParserChipExtension,
		Placeholder.configure({ placeholder, showOnlyWhenEditable: false }),
		DivNodeExtension, // Support divs.
	];
}

function getRichTextMenuExtensions() {
	const LinkModified = Link.extend({
		addAttributes() {
			return {
				plySource: { default: null },
				href: { default: null },
				target: { default: this.options.HTMLAttributes.target },
				class: { default: this.options.HTMLAttributes.class },
			};
		},
	}).configure({
		openOnClick: false,
		validate: (href) => !/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/.test(href), // Exclude images
		HTMLAttributes: {
			target: '_blank',
		},
	});
	const ImageModified = Image.extend({
		addAttributes() {
			return {
				plySource: { default: null },
				src: { default: null },
			};
		},
	}).configure({ allowBase64: true });

	return [Underline, TextStyle, FontSize, LinkModified, Color.configure({ types: ['textStyle'] }), ImageModified];
}

const ExtensionsService = {
	getBasicExtensions,
	getRichTextMenuExtensions,
};

export default ExtensionsService;
